import { defineStore } from 'pinia';

export const useAlertStore = defineStore({
    id: 'alert',
    state: () => ({
        alert: null 
    }),
    actions: {
        success(message) {
            this.alert = { message, type: 'success' };
            setInterval(()=>{ this.alert = null; }, 15000);
        },
        error(message) {
            this.alert = { message, type: 'error' };
            setInterval(()=>{ this.alert = null; }, 15000);
        },
        clear() {
            this.alert = null;
        }
    }
});
